/* eslint-disabled */

export default class EmailJobExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
